import React from "react";
import Layout from "./src/components/Layout";
import { LanguageProvider } from "./src/contexts/LanguageContext";

export const wrapRootElement = ({ element }) => (
  <LanguageProvider>{element}</LanguageProvider>
);

export function wrapPageElement({ element, props }) {
  return <Layout {...props}>{element}</Layout>;
}